<template>
  <BCard no-body v-draggable class="popup text-dark" :style="'width: ' + width">
    <BCardHeader
      style="height: 25px; user-select: none;"
      class="ps-2 pb-0 pt-0"
      header-tag="div"
    >
      <BRow class="mx-0 px-0">
        <BCol class="mx-0 px-0" cols="11">
          {{ title }}
        </BCol>
        <BCol class="mx-0 px-0" cols="1" style="display: flex; justify-content: end;">
          <div @click="$emit('close')">
            <FontAwesomeIcon
              class="mx-1 clickable"
              icon="fa-solid fa-xmark"
              style="cursor:pointer;"
            />            
          </div>
        </BCol>
      </BRow>
    </BCardHeader>

    <BCardBody :style="`max-height: ${max_height}; overflow: auto;`">
      <slot></slot>
    </BCardBody>
  </BCard>
</template>

<script>
export default {
  emits: ['close'],
  name: "GenericPopup",
  props: {
    title: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: '75vw'
    },
    max_height: {
      type: String,
      default: '50vh'
    },

  }
}
</script>

<style scoped>
  .popup {
    width: 450px;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  }
</style>